/**
 * GENERATED CODE – DO NOT EDIT!
 */
/* eslint-disable */
import * as $protobuf from 'protobufjs/light';
import { fixType } from '../../../../Fixes';
import Builder from '../../../../Builder';
import '../../translation_types';
import '../../../common/currency';
import '../../../items/items';
import '../../../bills/cart';
import '../../../common/colors';
import '../../../omg/model/orders';
import './users';
import './payment';
import '../../../common/time';
import '../../v3/bill';
import '../../v3/reporting_params';
import './refund_v3';
import '../../../bills/square_product_attributes';
import '../../../common/payment';
import '../../../omg/fulfillment/fulfillment';
import '../../../team_member_attribution/model';
const $root = $protobuf.roots['default'] || ($protobuf.roots['default'] = new $protobuf.Root());
const jsonData = {
  "squareup": {
    "nested": {
      "beemo": {
        "nested": {
          "api": {
            "nested": {
              "v2": {
                "nested": {
                  "models": {
                    "nested": {
                      "Adjustment": {
                        "fields": {
                          "type": {
                            "type": "squareup.beemo.api.v2.models.Adjustment.AdjustmentType",
                            "id": 1,
                            "rule": "optional"
                          },
                          "nameOrTranslationType": {
                            "type": "squareup.beemo.translation_types.NameOrTranslationType",
                            "id": 2,
                            "rule": "optional"
                          },
                          "appliedMoney": {
                            "type": "squareup.common.Money",
                            "id": 3,
                            "rule": "optional"
                          },
                          "rate": {
                            "type": "double",
                            "id": 10,
                            "rule": "optional"
                          },
                          "inclusionType": {
                            "type": "squareup.api.items.Fee.InclusionType",
                            "id": 11,
                            "rule": "optional"
                          },
                          "adjustmentGroup": {
                            "type": "string",
                            "id": 12,
                            "rule": "optional"
                          },
                          "couponToken": {
                            "type": "string",
                            "id": 13,
                            "rule": "optional"
                          },
                          "modifierList": {
                            "type": "squareup.beemo.api.v2.models.Adjustment.ModifierList",
                            "id": 14,
                            "rule": "optional"
                          },
                          "appliedToMoney": {
                            "type": "squareup.common.Money",
                            "id": 15,
                            "rule": "optional"
                          },
                          "afterApplicationTotalMoney": {
                            "type": "squareup.common.Money",
                            "id": 16,
                            "rule": "optional"
                          },
                          "taxLabelOrder": {
                            "type": "int32",
                            "id": 17,
                            "rule": "optional"
                          },
                          "modifierQuantities": {
                            "type": "squareup.bills.ModifierOptionLineItem.FeatureDetails.Quantities",
                            "id": 18,
                            "rule": "optional"
                          },
                          "conversationalModes": {
                            "type": "squareup.bills.ModifierOptionLineItem.FeatureDetails.ConversationalMode",
                            "id": 19,
                            "rule": "repeated"
                          },
                          "surchargeType": {
                            "type": "squareup.api.items.Surcharge.Type",
                            "id": 20,
                            "rule": "optional"
                          },
                          "tax": {
                            "type": "squareup.beemo.api.v2.models.Adjustment",
                            "id": 21,
                            "rule": "repeated"
                          },
                          "discountQuantity": {
                            "type": "string",
                            "id": 22,
                            "rule": "optional"
                          },
                          "couponTokens": {
                            "type": "string",
                            "id": 23,
                            "rule": "repeated"
                          },
                          "modifyTaxBasis": {
                            "type": "squareup.api.items.Discount.ModifyTaxBasis",
                            "id": 24,
                            "rule": "optional",
                            "options": {
                              "default": "MODIFY_TAX_BASIS"
                            }
                          },
                          "applicationScope": {
                            "type": "squareup.beemo.api.v2.models.Adjustment.ApplicationScope",
                            "id": 25,
                            "rule": "optional"
                          },
                          "surchargeTreatmentType": {
                            "type": "squareup.api.items.Surcharge.TreatmentType",
                            "id": 26,
                            "rule": "optional"
                          },
                          "comboDetails": {
                            "type": "squareup.beemo.api.v2.models.Adjustment.ComboDetails",
                            "id": 27,
                            "rule": "optional"
                          }
                        },
                        "nested": {
                          "AdjustmentType": {
                            "values": {
                              "TAX": 0,
                              "UNITEMIZED_TAX": 1,
                              "INCLUSIVE_TAX": 2,
                              "DISCOUNT": 3,
                              "REWARD": 4,
                              "COUPON": 5,
                              "ITEM_MODIFIER": 6,
                              "COMP": 7,
                              "SURCHARGE": 8,
                              "COMBO": 9
                            }
                          },
                          "ModifierList": {
                            "fields": {
                              "id": {
                                "type": "string",
                                "id": 1,
                                "rule": "optional"
                              },
                              "name": {
                                "type": "string",
                                "id": 2,
                                "rule": "optional"
                              },
                              "selectionType": {
                                "type": "squareup.beemo.api.v2.models.Adjustment.ModifierList.SelectionType",
                                "id": 3,
                                "rule": "optional"
                              }
                            },
                            "nested": {
                              "SelectionType": {
                                "values": {
                                  "SINGLE": 0,
                                  "MULTIPLE": 1
                                }
                              }
                            }
                          },
                          "ApplicationScope": {
                            "values": {
                              "UNKNOWN": 0,
                              "ITEMIZATION_LEVEL": 1,
                              "CART_LEVEL": 2
                            }
                          },
                          "ComboDetails": {
                            "fields": {
                              "comboPriceAdjustmentMoney": {
                                "type": "squareup.common.Money",
                                "id": 1,
                                "rule": "optional"
                              },
                              "comboAppliedMoney": {
                                "type": "squareup.common.Money",
                                "id": 2,
                                "rule": "optional"
                              },
                              "comboAppliedWeight": {
                                "type": "int64",
                                "id": 6,
                                "rule": "optional"
                              },
                              "appliedComboClientToken": {
                                "type": "string",
                                "id": 3,
                                "rule": "optional"
                              },
                              "appliedComboChoiceId": {
                                "type": "string",
                                "id": 4,
                                "rule": "optional"
                              },
                              "appliedComboChoiceName": {
                                "type": "string",
                                "id": 5,
                                "rule": "optional"
                              }
                            }
                          }
                        }
                      },
                      "ItemDetail": {
                        "fields": {
                          "categoryName": {
                            "type": "string",
                            "id": 1,
                            "rule": "optional"
                          },
                          "sku": {
                            "type": "string",
                            "id": 2,
                            "rule": "optional"
                          },
                          "imageUrl": {
                            "type": "string",
                            "id": 3,
                            "rule": "optional"
                          },
                          "iconColor": {
                            "type": "squareup.common.RGBAColor",
                            "id": 4,
                            "rule": "optional"
                          },
                          "itemId": {
                            "type": "string",
                            "id": 5,
                            "rule": "optional"
                          },
                          "itemVariationId": {
                            "type": "string",
                            "id": 6,
                            "rule": "optional"
                          },
                          "imageId": {
                            "type": "string",
                            "id": 7,
                            "rule": "optional"
                          },
                          "abbreviation": {
                            "type": "string",
                            "id": 8,
                            "rule": "optional"
                          },
                          "gtin": {
                            "type": "string",
                            "id": 9,
                            "rule": "optional"
                          }
                        }
                      },
                      "DiningOption": {
                        "fields": {
                          "id": {
                            "type": "string",
                            "id": 1,
                            "rule": "optional"
                          },
                          "name": {
                            "type": "string",
                            "id": 2,
                            "rule": "optional"
                          },
                          "ordinal": {
                            "type": "int64",
                            "id": 3,
                            "rule": "optional"
                          },
                          "type": {
                            "type": "squareup.beemo.api.v2.models.DiningOption.DiningOptionType",
                            "id": 4,
                            "rule": "optional"
                          }
                        },
                        "nested": {
                          "DiningOptionType": {
                            "values": {
                              "DEFAULT": 1,
                              "SELECTED": 2
                            }
                          }
                        }
                      },
                      "Itemization": {
                        "fields": {
                          "nameOrTranslationType": {
                            "type": "squareup.beemo.translation_types.NameOrTranslationType",
                            "id": 1,
                            "rule": "optional"
                          },
                          "quantity": {
                            "type": "double",
                            "id": 2,
                            "rule": "optional"
                          },
                          "totalMoney": {
                            "type": "squareup.common.Money",
                            "id": 3,
                            "rule": "optional"
                          },
                          "singleQuantityMoney": {
                            "type": "squareup.common.Money",
                            "id": 4,
                            "rule": "optional"
                          },
                          "multipleQuantityMoney": {
                            "type": "squareup.common.Money",
                            "id": 5,
                            "rule": "optional"
                          },
                          "productSalesMoney": {
                            "type": "squareup.common.Money",
                            "id": 28,
                            "rule": "optional"
                          },
                          "grossSalesMoney": {
                            "type": "squareup.common.Money",
                            "id": 6,
                            "rule": "optional"
                          },
                          "discountMoney": {
                            "type": "squareup.common.Money",
                            "id": 7,
                            "rule": "optional"
                          },
                          "refundedMoney": {
                            "type": "squareup.common.Money",
                            "id": 8,
                            "rule": "optional"
                          },
                          "netSalesMoney": {
                            "type": "squareup.common.Money",
                            "id": 9,
                            "rule": "optional"
                          },
                          "australianGrossSalesMoney": {
                            "type": "squareup.common.Money",
                            "id": 26,
                            "rule": "optional"
                          },
                          "giftCardNetSalesMoney": {
                            "type": "squareup.common.Money",
                            "id": 24,
                            "rule": "optional"
                          },
                          "itemVariationName": {
                            "type": "string",
                            "id": 10,
                            "rule": "optional"
                          },
                          "itemDetail": {
                            "type": "squareup.beemo.api.v2.models.ItemDetail",
                            "id": 11,
                            "rule": "optional"
                          },
                          "itemizationNotes": {
                            "type": "string",
                            "id": 12,
                            "rule": "optional"
                          },
                          "description": {
                            "type": "string",
                            "id": 33,
                            "rule": "optional"
                          },
                          "discount": {
                            "type": "squareup.beemo.api.v2.models.Adjustment",
                            "id": 20,
                            "rule": "repeated"
                          },
                          "tax": {
                            "type": "squareup.beemo.api.v2.models.Adjustment",
                            "id": 21,
                            "rule": "repeated"
                          },
                          "itemModifier": {
                            "type": "squareup.beemo.api.v2.models.Adjustment",
                            "id": 22,
                            "rule": "repeated"
                          },
                          "giftCardDetails": {
                            "type": "squareup.beemo.api.v2.models.Itemization.GiftCardDetails",
                            "id": 23,
                            "rule": "optional"
                          },
                          "diningOption": {
                            "type": "squareup.beemo.api.v2.models.DiningOption",
                            "id": 25,
                            "rule": "optional"
                          },
                          "event": {
                            "type": "squareup.bills.Itemization.Event",
                            "id": 27,
                            "rule": "repeated"
                          },
                          "fifoCostOfGoodsSoldAmounts": {
                            "type": "squareup.beemo.api.v2.models.Itemization.CostOfGoodsAmounts",
                            "id": 29,
                            "rule": "optional"
                          },
                          "lifoCostOfGoodsSoldAmounts": {
                            "type": "squareup.beemo.api.v2.models.Itemization.CostOfGoodsAmounts",
                            "id": 30,
                            "rule": "optional"
                          },
                          "averageCostOfGoodsSoldAmounts": {
                            "type": "squareup.beemo.api.v2.models.Itemization.CostOfGoodsAmounts",
                            "id": 31,
                            "rule": "optional"
                          },
                          "featureDetails": {
                            "type": "squareup.beemo.api.v2.models.Itemization.FeatureDetails",
                            "id": 32,
                            "rule": "optional"
                          },
                          "menu": {
                            "type": "squareup.beemo.api.v2.models.Itemization.Menu",
                            "id": 34,
                            "rule": "optional"
                          },
                          "quantityUnit": {
                            "type": "squareup.omg.model.Order.QuantityUnit",
                            "id": 35,
                            "rule": "optional"
                          },
                          "displayQuantity": {
                            "type": "string",
                            "id": 36,
                            "rule": "optional",
                            "options": {
                              "default": "1"
                            }
                          },
                          "commissionMoney": {
                            "type": "squareup.common.Money",
                            "id": 37,
                            "rule": "optional"
                          },
                          "employeeAttributions": {
                            "type": "squareup.beemo.api.v2.models.Itemization.EmployeeAttribution",
                            "id": 38,
                            "rule": "repeated"
                          },
                          "tierMin": {
                            "type": "int64",
                            "id": 39,
                            "rule": "optional"
                          },
                          "tierMax": {
                            "type": "int64",
                            "id": 40,
                            "rule": "optional"
                          },
                          "commissionBasisPoints": {
                            "type": "int64",
                            "id": 41,
                            "rule": "optional"
                          },
                          "itemType": {
                            "type": "squareup.api.items.Item.Type",
                            "id": 42,
                            "rule": "optional"
                          },
                          "itemCommissionMoney": {
                            "type": "squareup.common.Money",
                            "id": 43,
                            "rule": "optional"
                          },
                          "serviceCommissionMoney": {
                            "type": "squareup.common.Money",
                            "id": 44,
                            "rule": "optional"
                          },
                          "tierUnit": {
                            "type": "squareup.bills.Itemization.Amounts.ReportingAmounts.TierUnit",
                            "id": 45,
                            "rule": "optional"
                          },
                          "appliedItemizationGroups": {
                            "type": "string",
                            "id": 46,
                            "rule": "repeated"
                          },
                          "deductedServiceCostMoney": {
                            "type": "squareup.common.Money",
                            "id": 47,
                            "rule": "optional"
                          }
                        },
                        "nested": {
                          "GiftCardDetails": {
                            "fields": {
                              "hashedGiftCardToken": {
                                "type": "string",
                                "id": 1,
                                "rule": "optional"
                              },
                              "activityType": {
                                "type": "squareup.bills.Itemization.Configuration.SelectedOptions.ItemVariationDetails.GiftCardDetails.ActivityType",
                                "id": 2,
                                "rule": "optional"
                              },
                              "giftCardToken": {
                                "type": "string",
                                "id": 3,
                                "rule": "optional"
                              },
                              "panSuffix": {
                                "type": "string",
                                "id": 4,
                                "rule": "optional"
                              }
                            }
                          },
                          "CostOfGoodsAmounts": {
                            "fields": {
                              "itemVariationTotalCostMoney": {
                                "type": "squareup.common.Money",
                                "id": 1,
                                "rule": "optional"
                              },
                              "itemVariationCogsQuantity": {
                                "type": "string",
                                "id": 2,
                                "rule": "optional"
                              }
                            }
                          },
                          "FeatureDetails": {
                            "fields": {
                              "seating": {
                                "type": "squareup.bills.Itemization.FeatureDetails.Seating",
                                "id": 1,
                                "rule": "optional"
                              },
                              "lineItemSplitDetails": {
                                "type": "squareup.bills.Itemization.FeatureDetails.LineItemSplitDetails",
                                "id": 2,
                                "rule": "optional"
                              }
                            }
                          },
                          "Menu": {
                            "fields": {
                              "name": {
                                "type": "string",
                                "id": 1,
                                "rule": "optional"
                              },
                              "cogsObjectId": {
                                "type": "string",
                                "id": 2,
                                "rule": "optional"
                              }
                            }
                          },
                          "EmployeeAttribution": {
                            "fields": {
                              "employee": {
                                "type": "squareup.beemo.api.v2.models.Employee",
                                "id": 1,
                                "rule": "optional"
                              }
                            }
                          }
                        }
                      },
                      "ReturnItemization": {
                        "fields": {
                          "itemization": {
                            "type": "squareup.beemo.api.v2.models.Itemization",
                            "id": 1,
                            "rule": "optional"
                          },
                          "sourceItemizationToken": {
                            "type": "string",
                            "id": 2,
                            "rule": "optional"
                          }
                        }
                      },
                      "FeatureDetails": {
                        "fields": {
                          "openTicket": {
                            "type": "squareup.beemo.api.v2.models.FeatureDetails.OpenTicket",
                            "id": 1,
                            "rule": "optional"
                          },
                          "seating": {
                            "type": "squareup.bills.Cart.FeatureDetails.Seating",
                            "id": 2,
                            "rule": "optional"
                          },
                          "appointmentsDetails": {
                            "type": "squareup.bills.Cart.FeatureDetails.AppointmentsDetails",
                            "id": 3,
                            "rule": "optional"
                          },
                          "lifecycleEventTransferEmployee": {
                            "type": "squareup.beemo.api.v2.models.CreatorDetails",
                            "id": 4,
                            "rule": "optional"
                          },
                          "invoice": {
                            "type": "squareup.bills.Cart.FeatureDetails.Invoice",
                            "id": 5,
                            "rule": "optional"
                          }
                        },
                        "nested": {
                          "OpenTicket": {
                            "fields": {
                              "ticketOwner": {
                                "type": "squareup.beemo.api.v2.models.CreatorDetails",
                                "id": 1,
                                "rule": "optional"
                              },
                              "name": {
                                "type": "string",
                                "id": 2,
                                "rule": "optional"
                              },
                              "predefinedTicket": {
                                "type": "squareup.beemo.api.v2.models.FeatureDetails.OpenTicket.PredefinedTicket",
                                "id": 3,
                                "rule": "optional"
                              }
                            },
                            "nested": {
                              "PredefinedTicket": {
                                "fields": {
                                  "ticketGroup": {
                                    "type": "squareup.api.items.TicketGroup",
                                    "id": 1,
                                    "rule": "optional"
                                  },
                                  "ticketTemplate": {
                                    "type": "squareup.api.items.TicketTemplate",
                                    "id": 2,
                                    "rule": "optional"
                                  }
                                }
                              }
                            }
                          }
                        }
                      },
                      "TipLineItem": {
                        "fields": {
                          "appliedMoney": {
                            "type": "squareup.common.Money",
                            "id": 1,
                            "rule": "optional"
                          },
                          "tenderServerToken": {
                            "type": "string",
                            "id": 2,
                            "rule": "optional"
                          }
                        }
                      },
                      "BeemoCart": {
                        "fields": {
                          "returnLineItem": {
                            "type": "squareup.beemo.api.v2.models.BeemoCart.ReturnLineItem",
                            "id": 1,
                            "rule": "repeated"
                          },
                          "returnAmounts": {
                            "type": "squareup.beemo.api.v2.models.Amounts",
                            "id": 2,
                            "rule": "optional"
                          }
                        },
                        "nested": {
                          "ReturnLineItem": {
                            "fields": {
                              "returnTipLineItem": {
                                "type": "squareup.beemo.api.v2.models.BeemoCart.ReturnLineItem.ReturnTipLineItem",
                                "id": 1,
                                "rule": "repeated"
                              },
                              "returnSwedishRoundingMoney": {
                                "type": "squareup.common.Money",
                                "id": 2,
                                "rule": "optional"
                              },
                              "returnItemization": {
                                "type": "squareup.beemo.api.v2.models.ReturnItemization",
                                "id": 3,
                                "rule": "repeated"
                              },
                              "returnLineItemType": {
                                "type": "squareup.beemo.api.v2.models.BeemoCart.ReturnLineItem.ReturnLineItemType",
                                "id": 4,
                                "rule": "optional"
                              },
                              "returnSurcharge": {
                                "type": "squareup.beemo.api.v2.models.Adjustment",
                                "id": 5,
                                "rule": "repeated"
                              },
                              "returnTax": {
                                "type": "squareup.beemo.api.v2.models.Adjustment",
                                "id": 6,
                                "rule": "repeated"
                              },
                              "returnDiscount": {
                                "type": "squareup.beemo.api.v2.models.Adjustment",
                                "id": 7,
                                "rule": "repeated"
                              }
                            },
                            "nested": {
                              "ReturnTipLineItem": {
                                "fields": {
                                  "tipLineItem": {
                                    "type": "squareup.beemo.api.v2.models.TipLineItem",
                                    "id": 1,
                                    "rule": "optional"
                                  }
                                }
                              },
                              "ReturnLineItemType": {
                                "values": {
                                  "AMOUNT_BASED": 0,
                                  "ITEMIZED": 1
                                }
                              }
                            }
                          }
                        }
                      },
                      "Amounts": {
                        "fields": {
                          "productSalesMoney": {
                            "type": "squareup.common.Money",
                            "id": 1,
                            "rule": "optional"
                          },
                          "grossSalesMoney": {
                            "type": "squareup.common.Money",
                            "id": 2,
                            "rule": "optional"
                          },
                          "discountMoney": {
                            "type": "squareup.common.Money",
                            "id": 3,
                            "rule": "optional"
                          },
                          "netSalesMoney": {
                            "type": "squareup.common.Money",
                            "id": 4,
                            "rule": "optional"
                          },
                          "inclusiveTaxMoney": {
                            "type": "squareup.common.Money",
                            "id": 5,
                            "rule": "optional"
                          },
                          "additiveTaxMoney": {
                            "type": "squareup.common.Money",
                            "id": 6,
                            "rule": "optional"
                          },
                          "taxMoney": {
                            "type": "squareup.common.Money",
                            "id": 7,
                            "rule": "optional"
                          },
                          "tipMoney": {
                            "type": "squareup.common.Money",
                            "id": 8,
                            "rule": "optional"
                          },
                          "totalCollectedMoney": {
                            "type": "squareup.common.Money",
                            "id": 9,
                            "rule": "optional"
                          },
                          "processingFeeMoney": {
                            "type": "squareup.common.Money",
                            "id": 10,
                            "rule": "optional"
                          },
                          "netTotalMoney": {
                            "type": "squareup.common.Money",
                            "id": 11,
                            "rule": "optional"
                          },
                          "totalDepositedMoney": {
                            "type": "squareup.common.Money",
                            "id": 12,
                            "rule": "optional"
                          },
                          "totalDepositedMoneyAfterFreeProcessing": {
                            "type": "squareup.common.Money",
                            "id": 18,
                            "rule": "optional"
                          },
                          "swedishRoundingMoney": {
                            "type": "squareup.common.Money",
                            "id": 13,
                            "rule": "optional"
                          },
                          "surchargeMoney": {
                            "type": "squareup.common.Money",
                            "id": 14,
                            "rule": "optional"
                          },
                          "surchargeInclusiveTaxMoney": {
                            "type": "squareup.common.Money",
                            "id": 15,
                            "rule": "optional"
                          },
                          "giftCardNetSalesMoney": {
                            "type": "squareup.common.Money",
                            "id": 16,
                            "rule": "optional"
                          },
                          "processingFeeAmounts": {
                            "type": "squareup.beemo.api.v2.models.ProcessingFeeAmounts",
                            "id": 17,
                            "rule": "optional"
                          }
                        }
                      },
                      "Transaction": {
                        "fields": {
                          "merchantToken": {
                            "type": "string",
                            "id": 4,
                            "rule": "optional"
                          },
                          "billToken": {
                            "type": "string",
                            "id": 2,
                            "rule": "optional"
                          },
                          "billEventToken": {
                            "type": "string",
                            "id": 51,
                            "rule": "optional"
                          },
                          "completedAt": {
                            "type": "squareup.common.time.DateTime",
                            "id": 3,
                            "rule": "optional"
                          },
                          "eventType": {
                            "type": "squareup.beemo.v3.EventType",
                            "id": 42,
                            "rule": "optional"
                          },
                          "activityType": {
                            "type": "squareup.beemo.itemizations.api.v3.ActivityType",
                            "id": 54,
                            "rule": "optional",
                            "options": {
                              "default": "BOOKED"
                            }
                          },
                          "subunitMerchant": {
                            "type": "squareup.beemo.api.v2.models.Merchant",
                            "id": 12,
                            "rule": "optional"
                          },
                          "tender": {
                            "type": "squareup.beemo.api.v2.models.Tender",
                            "id": 24,
                            "rule": "repeated"
                          },
                          "refund": {
                            "type": "squareup.beemo.api.v2.models.Refund",
                            "id": 26,
                            "rule": "repeated"
                          },
                          "refundV3": {
                            "type": "squareup.beemo.api.v2.models.BeemoRefundV3",
                            "id": 27,
                            "rule": "repeated"
                          },
                          "itemization": {
                            "type": "squareup.beemo.api.v2.models.Itemization",
                            "id": 20,
                            "rule": "repeated"
                          },
                          "voidItemization": {
                            "type": "squareup.beemo.api.v2.models.Itemization",
                            "id": 53,
                            "rule": "repeated"
                          },
                          "inclusiveTax": {
                            "type": "squareup.beemo.api.v2.models.Adjustment",
                            "id": 21,
                            "rule": "repeated"
                          },
                          "additiveTax": {
                            "type": "squareup.beemo.api.v2.models.Adjustment",
                            "id": 22,
                            "rule": "repeated"
                          },
                          "discounts": {
                            "type": "squareup.beemo.api.v2.models.Adjustment",
                            "id": 45,
                            "rule": "repeated"
                          },
                          "surcharges": {
                            "type": "squareup.beemo.api.v2.models.Adjustment",
                            "id": 61,
                            "rule": "repeated"
                          },
                          "returnCart": {
                            "type": "squareup.beemo.api.v2.models.BeemoCart",
                            "id": 60,
                            "rule": "optional"
                          },
                          "productSalesMoney": {
                            "type": "squareup.common.Money",
                            "id": 56,
                            "rule": "optional"
                          },
                          "grossSalesMoney": {
                            "type": "squareup.common.Money",
                            "id": 30,
                            "rule": "optional"
                          },
                          "discountMoney": {
                            "type": "squareup.common.Money",
                            "id": 31,
                            "rule": "optional"
                          },
                          "netSalesMoney": {
                            "type": "squareup.common.Money",
                            "id": 32,
                            "rule": "optional"
                          },
                          "inclusiveTaxMoney": {
                            "type": "squareup.common.Money",
                            "id": 33,
                            "rule": "optional"
                          },
                          "additiveTaxMoney": {
                            "type": "squareup.common.Money",
                            "id": 34,
                            "rule": "optional"
                          },
                          "taxMoney": {
                            "type": "squareup.common.Money",
                            "id": 35,
                            "rule": "optional"
                          },
                          "tipMoney": {
                            "type": "squareup.common.Money",
                            "id": 23,
                            "rule": "optional"
                          },
                          "totalCollectedMoney": {
                            "type": "squareup.common.Money",
                            "id": 36,
                            "rule": "optional"
                          },
                          "processingFeeMoney": {
                            "type": "squareup.common.Money",
                            "id": 37,
                            "rule": "optional"
                          },
                          "netTotalMoney": {
                            "type": "squareup.common.Money",
                            "id": 38,
                            "rule": "optional"
                          },
                          "totalDepositedMoney": {
                            "type": "squareup.common.Money",
                            "id": 39,
                            "rule": "optional"
                          },
                          "totalDepositedMoneyAfterFreeProcessing": {
                            "type": "squareup.common.Money",
                            "id": 71,
                            "rule": "optional"
                          },
                          "refundedMoney": {
                            "type": "squareup.common.Money",
                            "id": 40,
                            "rule": "optional"
                          },
                          "swedishRoundingMoney": {
                            "type": "squareup.common.Money",
                            "id": 43,
                            "rule": "optional"
                          },
                          "surchargeMoney": {
                            "type": "squareup.common.Money",
                            "id": 44,
                            "rule": "optional"
                          },
                          "surchargeInclusiveTaxMoney": {
                            "type": "squareup.common.Money",
                            "id": 46,
                            "rule": "optional"
                          },
                          "giftCardNetSalesMoney": {
                            "type": "squareup.common.Money",
                            "id": 47,
                            "rule": "optional"
                          },
                          "processingFeeAmounts": {
                            "type": "squareup.beemo.api.v2.models.ProcessingFeeAmounts",
                            "id": 55,
                            "rule": "optional"
                          },
                          "billNote": {
                            "type": "string",
                            "id": 48,
                            "rule": "optional"
                          },
                          "defaultDiningOption": {
                            "type": "squareup.beemo.api.v2.models.DiningOption",
                            "id": 49,
                            "rule": "optional"
                          },
                          "virtualRegisterDetails": {
                            "type": "squareup.bills.CommonPointOfSaleAttributes.VirtualRegister",
                            "id": 52,
                            "rule": "optional"
                          },
                          "featureDetails": {
                            "type": "squareup.beemo.api.v2.models.FeatureDetails",
                            "id": 57,
                            "rule": "optional"
                          },
                          "squareProduct": {
                            "type": "squareup.common.payment.SquareProduct",
                            "id": 59,
                            "rule": "optional"
                          },
                          "paymentToken": {
                            "type": "string",
                            "id": 1,
                            "rule": "optional"
                          },
                          "totalMoney": {
                            "type": "squareup.common.Money",
                            "id": 5,
                            "rule": "optional"
                          },
                          "creator": {
                            "type": "squareup.beemo.api.v2.models.Merchant",
                            "id": 10,
                            "rule": "optional"
                          },
                          "device": {
                            "type": "squareup.beemo.api.v2.models.Device",
                            "id": 11,
                            "rule": "optional"
                          },
                          "fullRefund": {
                            "type": "squareup.beemo.api.v2.models.FullRefund",
                            "id": 25,
                            "rule": "optional"
                          },
                          "australianGrossSalesMoney": {
                            "type": "squareup.common.Money",
                            "id": 50,
                            "rule": "optional"
                          },
                          "netAmounts": {
                            "type": "squareup.beemo.api.v2.models.Amounts",
                            "id": 62,
                            "rule": "optional"
                          },
                          "fulfillment": {
                            "type": "squareup.omg.fulfillment.Fulfillment",
                            "id": 63,
                            "rule": "repeated"
                          },
                          "orderReferenceId": {
                            "type": "string",
                            "id": 64,
                            "rule": "optional"
                          },
                          "orderShortReferenceId": {
                            "type": "string",
                            "id": 65,
                            "rule": "optional"
                          },
                          "orderSource": {
                            "type": "squareup.omg.model.Order.Source",
                            "id": 66,
                            "rule": "optional"
                          },
                          "externalApiReferenceId": {
                            "type": "string",
                            "id": 67,
                            "rule": "optional"
                          },
                          "saleAmountsEmployeeAttribution": {
                            "type": "squareup.beemo.api.v2.models.Transaction.EmployeeAttributionDetails",
                            "id": 68,
                            "rule": "repeated"
                          },
                          "returnAmountsEmployeeAttribution": {
                            "type": "squareup.beemo.api.v2.models.Transaction.EmployeeAttributionDetails",
                            "id": 69,
                            "rule": "repeated"
                          },
                          "sequentialNumber": {
                            "type": "string",
                            "id": 70,
                            "rule": "optional"
                          },
                          "channels": {
                            "type": "squareup.omg.model.Order.ChannelAttribution",
                            "id": 72,
                            "rule": "repeated"
                          },
                          "itemizationGroups": {
                            "type": "squareup.bills.ItemizationGroup",
                            "id": 73,
                            "rule": "repeated"
                          }
                        },
                        "nested": {
                          "EmployeeAttributionDetails": {
                            "fields": {
                              "employee": {
                                "type": "squareup.beemo.api.v2.models.Employee",
                                "id": 1,
                                "rule": "optional"
                              },
                              "tipMoney": {
                                "type": "squareup.common.Money",
                                "id": 2,
                                "rule": "optional"
                              },
                              "autoGratuityMoney": {
                                "type": "squareup.common.Money",
                                "id": 3,
                                "rule": "optional"
                              },
                              "totalCommissionMoney": {
                                "type": "squareup.common.Money",
                                "id": 4,
                                "rule": "optional"
                              },
                              "totalItemCommissionMoney": {
                                "type": "squareup.common.Money",
                                "id": 5,
                                "rule": "optional"
                              },
                              "totalServiceCommissionMoney": {
                                "type": "squareup.common.Money",
                                "id": 6,
                                "rule": "optional"
                              },
                              "tipDistributionMethod": {
                                "type": "squareup.team_member_attribution.TeamMemberAttributionDetails.TipDistributionMethod",
                                "id": 7,
                                "rule": "optional"
                              },
                              "timecardToken": {
                                "type": "string",
                                "id": 8,
                                "rule": "optional"
                              },
                              "tipPeriod": {
                                "type": "squareup.team_member_attribution.TipPeriod",
                                "id": 9,
                                "rule": "optional"
                              }
                            }
                          }
                        }
                      }
                    }
                  }
                }
              }
            }
          }
        }
      }
    }
  }
};

// Do not initialize these protos if they have already been defined
if (!$root.nested?.squareup?.nested?.beemo?.nested?.api?.nested?.v2?.nested?.models?.nested?.Adjustment && !$root.nested?.squareup?.nested?.beemo?.nested?.api?.nested?.v2?.nested?.models?.nested?.Adjustment?.nested?.AdjustmentType && !$root.nested?.squareup?.nested?.beemo?.nested?.api?.nested?.v2?.nested?.models?.nested?.Adjustment?.nested?.ModifierList && !$root.nested?.squareup?.nested?.beemo?.nested?.api?.nested?.v2?.nested?.models?.nested?.Adjustment?.nested?.ModifierList?.nested?.SelectionType && !$root.nested?.squareup?.nested?.beemo?.nested?.api?.nested?.v2?.nested?.models?.nested?.Adjustment?.nested?.ApplicationScope && !$root.nested?.squareup?.nested?.beemo?.nested?.api?.nested?.v2?.nested?.models?.nested?.Adjustment?.nested?.ComboDetails && !$root.nested?.squareup?.nested?.beemo?.nested?.api?.nested?.v2?.nested?.models?.nested?.ItemDetail && !$root.nested?.squareup?.nested?.beemo?.nested?.api?.nested?.v2?.nested?.models?.nested?.DiningOption && !$root.nested?.squareup?.nested?.beemo?.nested?.api?.nested?.v2?.nested?.models?.nested?.DiningOption?.nested?.DiningOptionType && !$root.nested?.squareup?.nested?.beemo?.nested?.api?.nested?.v2?.nested?.models?.nested?.Itemization && !$root.nested?.squareup?.nested?.beemo?.nested?.api?.nested?.v2?.nested?.models?.nested?.Itemization?.nested?.GiftCardDetails && !$root.nested?.squareup?.nested?.beemo?.nested?.api?.nested?.v2?.nested?.models?.nested?.Itemization?.nested?.CostOfGoodsAmounts && !$root.nested?.squareup?.nested?.beemo?.nested?.api?.nested?.v2?.nested?.models?.nested?.Itemization?.nested?.FeatureDetails && !$root.nested?.squareup?.nested?.beemo?.nested?.api?.nested?.v2?.nested?.models?.nested?.Itemization?.nested?.Menu && !$root.nested?.squareup?.nested?.beemo?.nested?.api?.nested?.v2?.nested?.models?.nested?.Itemization?.nested?.EmployeeAttribution && !$root.nested?.squareup?.nested?.beemo?.nested?.api?.nested?.v2?.nested?.models?.nested?.ReturnItemization && !$root.nested?.squareup?.nested?.beemo?.nested?.api?.nested?.v2?.nested?.models?.nested?.FeatureDetails && !$root.nested?.squareup?.nested?.beemo?.nested?.api?.nested?.v2?.nested?.models?.nested?.FeatureDetails?.nested?.OpenTicket && !$root.nested?.squareup?.nested?.beemo?.nested?.api?.nested?.v2?.nested?.models?.nested?.FeatureDetails?.nested?.OpenTicket?.nested?.PredefinedTicket && !$root.nested?.squareup?.nested?.beemo?.nested?.api?.nested?.v2?.nested?.models?.nested?.TipLineItem && !$root.nested?.squareup?.nested?.beemo?.nested?.api?.nested?.v2?.nested?.models?.nested?.BeemoCart && !$root.nested?.squareup?.nested?.beemo?.nested?.api?.nested?.v2?.nested?.models?.nested?.BeemoCart?.nested?.ReturnLineItem && !$root.nested?.squareup?.nested?.beemo?.nested?.api?.nested?.v2?.nested?.models?.nested?.BeemoCart?.nested?.ReturnLineItem?.nested?.ReturnTipLineItem && !$root.nested?.squareup?.nested?.beemo?.nested?.api?.nested?.v2?.nested?.models?.nested?.BeemoCart?.nested?.ReturnLineItem?.nested?.ReturnLineItemType && !$root.nested?.squareup?.nested?.beemo?.nested?.api?.nested?.v2?.nested?.models?.nested?.Amounts && !$root.nested?.squareup?.nested?.beemo?.nested?.api?.nested?.v2?.nested?.models?.nested?.Transaction && !$root.nested?.squareup?.nested?.beemo?.nested?.api?.nested?.v2?.nested?.models?.nested?.Transaction?.nested?.EmployeeAttributionDetails) {
  $root.addJSON(jsonData);
}

/**
 * Adjustments include discounts, taxes, and item modifiers.
 * They are not an item, but affect the price charged for that item.
 * They are modeled in one common proto, since they share common fields.
 *
 * SOURCE Adjustment @ squareup/beemo/v2/models/bill.proto at 29:1
 */
export const Adjustment = $root.lookupType('squareup.beemo.api.v2.models.Adjustment');
fixType(Adjustment);
Builder.createAndAttachToType(Adjustment);
/**
 * Required fields.
 *
 * SOURCE AdjustmentType @ squareup/beemo/v2/models/bill.proto at 31:3
 */
Adjustment.AdjustmentType = $root.lookupEnum('squareup.beemo.api.v2.models.Adjustment.AdjustmentType').values;
/**
 * SOURCE ModifierList @ squareup/beemo/v2/models/bill.proto at 71:3
 */
Adjustment.ModifierList = $root.lookupType('squareup.beemo.api.v2.models.Adjustment.ModifierList');
fixType(Adjustment.ModifierList);
Builder.createAndAttachToType(Adjustment.ModifierList);
/**
 * SOURCE SelectionType @ squareup/beemo/v2/models/bill.proto at 72:5
 */
Adjustment.ModifierList.SelectionType = $root.lookupEnum('squareup.beemo.api.v2.models.Adjustment.ModifierList.SelectionType').values;
/**
 * SOURCE ApplicationScope @ squareup/beemo/v2/models/bill.proto at 124:3
 */
Adjustment.ApplicationScope = $root.lookupEnum('squareup.beemo.api.v2.models.Adjustment.ApplicationScope').values;
/**
 * SOURCE ComboDetails @ squareup/beemo/v2/models/bill.proto at 135:3
 */
Adjustment.ComboDetails = $root.lookupType('squareup.beemo.api.v2.models.Adjustment.ComboDetails');
fixType(Adjustment.ComboDetails);
Builder.createAndAttachToType(Adjustment.ComboDetails);
/**
 * Items Service data for this item.
 *
 * SOURCE ItemDetail @ squareup/beemo/v2/models/bill.proto at 151:1
 */
export const ItemDetail = $root.lookupType('squareup.beemo.api.v2.models.ItemDetail');
fixType(ItemDetail);
Builder.createAndAttachToType(ItemDetail);
/**
 * Dining option
 *
 * SOURCE DiningOption @ squareup/beemo/v2/models/bill.proto at 185:1
 */
export const DiningOption = $root.lookupType('squareup.beemo.api.v2.models.DiningOption');
fixType(DiningOption);
Builder.createAndAttachToType(DiningOption);
/**
 * SOURCE DiningOptionType @ squareup/beemo/v2/models/bill.proto at 186:3
 */
DiningOption.DiningOptionType = $root.lookupEnum('squareup.beemo.api.v2.models.DiningOption.DiningOptionType').values;
/**
 * An itemization represents an item that is purchased by a customer in a transaction.
 *
 * SOURCE Itemization @ squareup/beemo/v2/models/bill.proto at 199:1
 */
export const Itemization = $root.lookupType('squareup.beemo.api.v2.models.Itemization');
fixType(Itemization);
Builder.createAndAttachToType(Itemization);
/**
 * SOURCE GiftCardDetails @ squareup/beemo/v2/models/bill.proto at 286:3
 */
Itemization.GiftCardDetails = $root.lookupType('squareup.beemo.api.v2.models.Itemization.GiftCardDetails');
fixType(Itemization.GiftCardDetails);
Builder.createAndAttachToType(Itemization.GiftCardDetails);
/**
 * SOURCE CostOfGoodsAmounts @ squareup/beemo/v2/models/bill.proto at 318:3
 */
Itemization.CostOfGoodsAmounts = $root.lookupType('squareup.beemo.api.v2.models.Itemization.CostOfGoodsAmounts');
fixType(Itemization.CostOfGoodsAmounts);
Builder.createAndAttachToType(Itemization.CostOfGoodsAmounts);
/**
 * Feature specific details attached to the itemization.
 *
 * SOURCE FeatureDetails @ squareup/beemo/v2/models/bill.proto at 348:3
 */
Itemization.FeatureDetails = $root.lookupType('squareup.beemo.api.v2.models.Itemization.FeatureDetails');
fixType(Itemization.FeatureDetails);
Builder.createAndAttachToType(Itemization.FeatureDetails);
/**
 * Optionally, the menu that this itemization was selected from.
 *
 * SOURCE Menu @ squareup/beemo/v2/models/bill.proto at 358:3
 */
Itemization.Menu = $root.lookupType('squareup.beemo.api.v2.models.Itemization.Menu');
fixType(Itemization.Menu);
Builder.createAndAttachToType(Itemization.Menu);
/**
 * SOURCE EmployeeAttribution @ squareup/beemo/v2/models/bill.proto at 375:3
 */
Itemization.EmployeeAttribution = $root.lookupType('squareup.beemo.api.v2.models.Itemization.EmployeeAttribution');
fixType(Itemization.EmployeeAttribution);
Builder.createAndAttachToType(Itemization.EmployeeAttribution);
/**
 * Itemization that represents the return.
 *
 * SOURCE ReturnItemization @ squareup/beemo/v2/models/bill.proto at 410:1
 */
export const ReturnItemization = $root.lookupType('squareup.beemo.api.v2.models.ReturnItemization');
fixType(ReturnItemization);
Builder.createAndAttachToType(ReturnItemization);
/**
 * SOURCE FeatureDetails @ squareup/beemo/v2/models/bill.proto at 421:1
 */
export const FeatureDetails = $root.lookupType('squareup.beemo.api.v2.models.FeatureDetails');
fixType(FeatureDetails);
Builder.createAndAttachToType(FeatureDetails);
/**
 * SOURCE OpenTicket @ squareup/beemo/v2/models/bill.proto at 424:3
 */
FeatureDetails.OpenTicket = $root.lookupType('squareup.beemo.api.v2.models.FeatureDetails.OpenTicket');
fixType(FeatureDetails.OpenTicket);
Builder.createAndAttachToType(FeatureDetails.OpenTicket);
/**
 * SOURCE PredefinedTicket @ squareup/beemo/v2/models/bill.proto at 430:5
 */
FeatureDetails.OpenTicket.PredefinedTicket = $root.lookupType('squareup.beemo.api.v2.models.FeatureDetails.OpenTicket.PredefinedTicket');
fixType(FeatureDetails.OpenTicket.PredefinedTicket);
Builder.createAndAttachToType(FeatureDetails.OpenTicket.PredefinedTicket);
/**
 * SOURCE TipLineItem @ squareup/beemo/v2/models/bill.proto at 449:1
 */
export const TipLineItem = $root.lookupType('squareup.beemo.api.v2.models.TipLineItem');
fixType(TipLineItem);
Builder.createAndAttachToType(TipLineItem);
/**
 * Cart and line items, currently only used for itemized refunds
 *
 * SOURCE BeemoCart @ squareup/beemo/v2/models/bill.proto at 456:1
 */
export const BeemoCart = $root.lookupType('squareup.beemo.api.v2.models.BeemoCart');
fixType(BeemoCart);
Builder.createAndAttachToType(BeemoCart);
/**
 * SOURCE ReturnLineItem @ squareup/beemo/v2/models/bill.proto at 457:3
 */
BeemoCart.ReturnLineItem = $root.lookupType('squareup.beemo.api.v2.models.BeemoCart.ReturnLineItem');
fixType(BeemoCart.ReturnLineItem);
Builder.createAndAttachToType(BeemoCart.ReturnLineItem);
/**
 * SOURCE ReturnTipLineItem @ squareup/beemo/v2/models/bill.proto at 458:5
 */
BeemoCart.ReturnLineItem.ReturnTipLineItem = $root.lookupType('squareup.beemo.api.v2.models.BeemoCart.ReturnLineItem.ReturnTipLineItem');
fixType(BeemoCart.ReturnLineItem.ReturnTipLineItem);
Builder.createAndAttachToType(BeemoCart.ReturnLineItem.ReturnTipLineItem);
/**
 * SOURCE ReturnLineItemType @ squareup/beemo/v2/models/bill.proto at 466:5
 */
BeemoCart.ReturnLineItem.ReturnLineItemType = $root.lookupEnum('squareup.beemo.api.v2.models.BeemoCart.ReturnLineItem.ReturnLineItemType').values;
/**
 * SOURCE Amounts @ squareup/beemo/v2/models/bill.proto at 483:1
 */
export const Amounts = $root.lookupType('squareup.beemo.api.v2.models.Amounts');
fixType(Amounts);
Builder.createAndAttachToType(Amounts);
/**
 * SOURCE Transaction @ squareup/beemo/v2/models/bill.proto at 532:1
 */
export const Transaction = $root.lookupType('squareup.beemo.api.v2.models.Transaction');
fixType(Transaction);
Builder.createAndAttachToType(Transaction);
/**
 * Attribution information about the tip and autograt split between employees.
 *
 * SOURCE EmployeeAttributionDetails @ squareup/beemo/v2/models/bill.proto at 685:3
 */
Transaction.EmployeeAttributionDetails = $root.lookupType('squareup.beemo.api.v2.models.Transaction.EmployeeAttributionDetails');
fixType(Transaction.EmployeeAttributionDetails);
Builder.createAndAttachToType(Transaction.EmployeeAttributionDetails);